<script>
import Loading from '../../components/loading.vue';
import Invoice from '../../components/mineTable/invoice.vue';
import InvoiceDetail from '../../components/mineTable/invoiceDetail.vue';
import InvoicePopup from '../../components/mineTable/invoicePopup.vue';

export default {
    name: "invoice",
    data() {
        return {
            tabs: [
                { text: '已开具发票', value: '1' },
                { text: '申请中发票', value: '2' },
                { text: '未申请发票', value: '3' },
            ],
            activeIndex: 2,
            list: [],
            isLoading: false,
            page: 1,
            totalPage: 1,
            // 列表弹窗
            isShowInvoiceList: false,
            // 发票抬头选择
            isShowChoose: false,
            // 选择的订单号
            selectedOrderCode: null,
            // 发票详情弹窗
            isShowInvoiceDetail: false,
            showActiveIndex: null,
        };
    },
    computed: {
    },
    components: {
        Loading,
        Invoice,
        InvoicePopup,
        InvoiceDetail,
    },
    mounted() {
        this.getOrderList();
    },
    destroyed() {},
    watch: {},
    methods: {
        // 切换tab
        changeTab(index) { 
            if (this.activeIndex == index) {
                return;
            }
            this.activeIndex = index;
            this.page = 1;
            this.totalPage = 1;
            this.list = [];
            this.getOrderList();
        },
        // 获取订单列表
        getOrderList() {
            this.isLoading = true;
            this.$store.dispatch('getShopOrderList', {
                page: this.page,
                limit: 10,
                invoice_type: this.tabs[this.activeIndex].value,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.totalPage = result.data.last_page;
                    this.list = this.list.concat(result.data.list);
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        // 加载更多订单
        loadMore() {
            if (this.page >= this.totalPage) {
                return;
            }
            this.page += 1;
            this.getOrderList();
        },
        // 抬头管理
        showInvoiceList() {
            this.isShowInvoiceList = true;
            this.isShowChoose = false;
        },
        // 申请发票
        applyInvoice(orderCode) {
            this.isShowInvoiceList = true;
            this.isShowChoose = true;
            this.selectedOrderCode = orderCode;
        },
        // 选择发票抬头后申请发票
        applyInvoiceAfterChoose(selectedInvoice) {
            // console.log('选择的发票抬头：', selectedInvoice);
            this.$store.dispatch('applyInvoice', {
                order_code: this.selectedOrderCode,
                invoice_id: selectedInvoice.id,
            }).then((result) => {
                if (result.code == 100) {
                    this.$showToast({ text: '发票申请成功，等待审核' });
                    this.isShowInvoiceList = false;
                    // 刷新列表
                    this.page = 1;
                    this.totalPage = 1;
                    this.list = [];
                    this.getOrderList();
                } else {
                    this.$showToast({ text: result.msg || '发票申请提交失败，请稍后重试' });
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '发票申请提交失败，请稍后重试' });
            });
        },
        // 显示发票详情弹窗
        showDetail(index) {
            this.showActiveIndex = index;
            this.isShowInvoiceDetail = true;
        },
        // 发票申请取消
        cancelInvoiceApplication(orderCode) {
            this.$store.dispatch('cancelInvoice', {
                order_code: orderCode,
            }).then((result) => {
                if (result.code == 100) {
                    this.$showToast({ text: '发票申请已取消' });
                    this.isShowInvoiceDetail = false;
                    // 刷新列表
                    this.page = 1;
                    this.totalPage = 1;
                    this.list = [];
                    this.getOrderList();
                } else {
                    this.$showToast({ text: result.msg || '发票申请取消失败，请稍后重试' });
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '发票申请取消失败，请稍后重试' });
            });
        },
    },
};
</script>

<template>
    <div class="invoice">
        <div class="top flex align_end justify_between">
            <p class="title only_pc">我的发票</p>
            <p class="title only_mobile"></p>
            <p class="btn_add" @click="showInvoiceList">抬头管理</p>
        </div>
        <div class="tabs">
            <div class="item" 
            v-for="(item, index) in tabs" :key="index" 
            :class="{active: activeIndex == index}"
            @click="changeTab(index)">{{ item.text }}</div>
        </div>
        <p class="no_more" v-if="list.length == 0">你还没有{{ this.tabs[this.activeIndex].text }}的订单</p>
        <!-- 列表 -->
        <Invoice v-else :data="list" :active-index="activeIndex" @show-detail="showDetail" @apply-invoice="applyInvoice" />
        <!--  -->
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <div class="flex justify_center" v-else-if="page < totalPage">
            <p class="load_more" @click="loadMore">查看更多</p>
        </div>
        <!-- 发票管理弹窗 -->
        <InvoicePopup :show="isShowInvoiceList" :is-show-choose="isShowChoose" @close="isShowInvoiceList = false" @choose-invoice="applyInvoiceAfterChoose" />
        <!-- 发票详情弹窗 -->
        <InvoiceDetail :show="isShowInvoiceDetail" :data="showActiveIndex != null ? list[showActiveIndex] : {}" @close="isShowInvoiceDetail = false" @cancel="cancelInvoiceApplication" />
    </div>
</template>

<style scoped lang="scss">
.invoice{
    .top{
        margin-bottom: .4rem;
        @media screen and (max-width: 750px) {
            margin-bottom: .1rem;
        }
        .title{
            margin-bottom: 0;
        }
        .btn_add{
            font-size: .16rem;
            cursor: pointer;
            @media screen and (max-width: 750px) {
                font-size: .24rem;
            }
        }
    }
    .tabs{
        display: flex;
        font-size: .16rem;
        gap: .3rem;
        color: #999;
        margin-bottom: .2rem;
        @media screen and (max-width: 750px) {
            font-size: .24rem;
            gap: .5rem;
        }
        .item{
            cursor: pointer;
            &:hover,
            &.active{
                color: var(--font_color);
            }
        }
    }
}
</style>